import { useState } from 'react';

export const auctionAccent = (value = '') => {
  const hash = Array.from(String(value)).reduce((sum, char) => sum + char.codePointAt(0), 0);
  return ['purple', 'green', 'blue', 'coral'][hash % 4];
};

export const AuctionAvatar = ({ src, name = '', team = false }) => {
  const [failedSource, setFailedSource] = useState(null);
  const text = String(name || '').trim();
  const initials = team ? (text.length <= 3 ? text : text.split(/\s+/).map(word => Array.from(word)[0]).slice(0, 2).join('')) : Array.from(text)[0];
  return <span className={`pav-avatar pav-accent-${auctionAccent(name)} ${team ? 'pav-avatar--team' : ''}`}>
    {src && src !== failedSource ? <img src={src} alt={text} onError={() => setFailedSource(src)} /> : <span aria-label={text || (team ? 'Team' : 'Player')}>{initials || (team ? 'T' : 'P')}</span>}
  </span>;
};

export const AuctionSectionTitle = ({ children, accent = 'blue' }) => <h2 className={`pav-section-title pav-accent-${accent}`}>{children}</h2>;
